import { BitkitCheckbox, BitkitCheckboxProps, BitkitLink } from '@bitrise/bitkit-v2';
import { Box } from '@chakra-ui/react/box';
import { Text } from '@chakra-ui/react/text';

import URLs from '@/enums/urls';

// `BitkitCheckboxProps` is a union (visible `labelText` vs. `aria-label`-only), and a plain `Omit`
// over a union keys off `keyof (A | B)` — the shared members — which drops `aria-label` from the
// public type. `helperText` goes too: this component owns the wording of a legal consent, and a
// helper would join the checkbox's accessible name.
type DistributiveOmit<T, K extends keyof any> = T extends unknown ? Omit<T, K> : never;

type TermsOfServiceAndPrivacyPolicyProps = DistributiveOmit<BitkitCheckboxProps, 'labelText' | 'helperText'>;

const TermsOfServiceAndPrivacyPolicy = (props: TermsOfServiceAndPrivacyPolicyProps) => (
  <Box>
    <BitkitCheckbox
      marginBlockEnd="12"
      {...props}
      labelText={
        <span>
          I agree to the Bitrise{' '}
          <BitkitLink colorVariant="purple" href={URLs.TERMS_OF_SERVICE} isExternal>
            Terms of Service
          </BitkitLink>
          .
        </span>
      }
    />
    <Text textStyle="body/sm/regular" color="text/secondary">
      Bitrise may use your data provided above to contact you via email about Bitrise news, events, webinars,
      whitepapers or send you other direct marketing communications. You may object at any time by unsubscribing in
      emails or visiting the{' '}
      <BitkitLink colorVariant="purple" href={URLs.COMMUNICATION_PREFERENCES} isExternal>
        Preference Center
      </BitkitLink>
      . By submitting your contact details, you acknowledge that you reviewed and understood our{' '}
      <BitkitLink colorVariant="purple" href={URLs.PRIVACY_POLICY} isExternal>
        Privacy Policy
      </BitkitLink>
      .
    </Text>
  </Box>
);

export default TermsOfServiceAndPrivacyPolicy;
